import React from 'react';
import classnames from 'classnames';
import _isFinite from 'lodash/isFinite';
import PropTypes from 'prop-types';
// Core components
import Badge from 'components/core/Badge';
import Box from 'components/core/Box';
// Custom
import { CollapseIconButton } from 'components/buttons/IconButtons';

const CollapseBoxTemplate = ({
  initiallyClosed,
  title,
  titleSize,
  numericValue,
  buttons,
  buttonsXsNewLine,
  children, onExpandChange,
}) => {
  const [open, setOpen] = React.useState(!initiallyClosed);

  const handleCollapse = () => {
    setOpen(!open);
    if (onExpandChange) {
      onExpandChange(!open);
    }
  };

  return (
    <div className="box box-default m-0">
      <Box
        type="defaultBackground"
        className={
          classnames('py-1 pr-1 pl-3 d-flex align-items-center', {
            'box-title-xsmall': titleSize === 'xs',
            'box-title-small': titleSize === 'sm',
            'box-title': titleSize === 'de',
          })
        }
      >
        <div className="d-flex flex-nowrap align-items-center w-100">
          <div
            role="button"
            tabIndex="-1"
            className="collapse-box-title"
            onClick={handleCollapse}
          >
            <div className="d-flex align-items-center">
              {_isFinite(numericValue) ? (
                <Badge content={numericValue} gap="large">
                  {title}
                </Badge>
              )
                : title}
            </div>
          </div>
          <div
            className={
              classnames('d-flex flex-wrap align-items-center collapse-box-header', {
                'hidden-xs-down': buttonsXsNewLine,
              })
            }
          >
            { buttons }
          </div>
        </div>
        <CollapseIconButton open={open} onClick={handleCollapse} />
      </Box>
      {buttonsXsNewLine && (
        <div className="box-header box-dark py-1 pr-1 hidden-sm-up">
          <div className="d-flex flex-wrap align-items-center justify-content-end">
            { buttons }
          </div>
        </div>
      )}
      <div
        className={
          classnames({
            'collapse.show': open,
            collapse: !open,
          })
        }
      >
        { children }
      </div>
    </div>
  );
};

CollapseBoxTemplate.propTypes = {
  initiallyClosed: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  titleSize: PropTypes.oneOf(['xs', 'sm', 'de']),
  numericValue: PropTypes.number,
  buttons: PropTypes.arrayOf(PropTypes.element),
  buttonsXsNewLine: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  onExpandChange: PropTypes.func,
};

CollapseBoxTemplate.defaultProps = {
  initiallyClosed: false,
  titleSize: 'de', // default size
  numericValue: null,
  buttons: null,
  buttonsXsNewLine: false,
  children: null,
  onExpandChange: null,
};

module.exports = CollapseBoxTemplate;



// WEBPACK FOOTER //
// ./components/templates/CollapseBoxTemplate.js